import { z } from 'zod'

const paymentMethodSchema = z.object({
  type: z.string(),
  exp_year: z.number().nullish(),
  exp_month: z.number().nullish(),
  last_four_digits: z.string().nullish(),
  payment_method_id: z.string(),
  is_default_payment: z.number(),

  //ach
  account_number: z.string().nullish(),
  routing_number: z.string().nullish(),
})

export type PaymentMethodType = z.infer<typeof paymentMethodSchema>

export const paymentMethodDTO = (data: unknown): PaymentMethodType[] => {
  if (!data) return []

  const safeParse = z.record(paymentMethodSchema).safeParse(data)
  if (safeParse.error) {
    console.log(safeParse.error, data);
    
    throw new Error(safeParse.error.message)
  }
  const result = Object.values(safeParse.data)
  // sort default to first
  return result.sort((a, b) => b.is_default_payment - a.is_default_payment)
}
